/**
 * 图片预览工具函数
 */

import { ImageViewer } from "antd-mobile";
import { NavigateFunction } from "react-router-dom";
import { useNavigate } from 'src/hooks/useNavigate';

export interface ImagePreviewOptions {
  images: string[];
  defaultIndex?: number;
}

/**
 * 显示图片预览页面
 * @param options 预览选项
 * @param navigate React Router 的 navigate 函数
 */
export const showImagePreview = (
  options: ImagePreviewOptions,
) => {
  const { images, defaultIndex = 0 } = options;
  
  if (!images || images.length === 0) {
    console.warn('No images provided for preview');
    return;
  }

  ImageViewer.Multi.show({ images, defaultIndex })
};

/**
 * 替代 ImageViewer.Multi.show 的函数
 * @param options 预览选项，与 antd-mobile ImageViewer 兼容
 * @param navigate React Router 的 navigate 函数
 */
// export const ImageViewerMultiShow = (
//   options: {
//     images: string[];
//     defaultIndex?: number;
//   }
// ) => {
//   showImagePreview(options);
// }; 